// Shared base-path helper for full-page navigations. Prefixes a root-absolute
// URL with the sub-app mount (window.chatwootConfig.basePath) unless it's empty,
// non-string, protocol-relative (`//host`), or already under the mount. Single
// source of truth so patched redirects don't each re-implement the logic; the
// build-time codemod (vite.config.ts / prefix-bare-nav) covers the STOCK bare
// literals this helper can't reach.
export const withBasePath = url => {
  const b =
    (typeof window !== 'undefined' &&
      window.chatwootConfig &&
      window.chatwootConfig.basePath) ||
    '';
  return b &&
    typeof url === 'string' &&
    url.charAt(0) === '/' &&
    url.charAt(1) !== '/' &&
    !url.startsWith(b + '/') &&
    url !== b
    ? b + url
    : url;
};

export const replaceRouteWithReload = url => {
  window.location = withBasePath(url);
};

export const userInitial = name => {
  const parts = name.split(/[ -]/).filter(Boolean);
  let initials = parts.map(part => part[0].toUpperCase()).join('');
  return initials.slice(0, 2);
};
